import axios from 'axios';
import { API_CONFIG } from '../config/env';

export interface MerchantClientCredentialInfo {
  clientId: string | null;
  clientSecretName: string | null;
  rotatedAtUtc?: string | null;
  lastUsedAtUtc?: string | null;
}

export interface MerchantClientCredentialGenerateResponse {
  clientId: string;
  clientSecret: string;
}

class MerchantClientCredentialsService {
  private getAuthHeaders() {
    const token = localStorage.getItem('accessToken');
    return {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    };
  }

  async getCredentials(): Promise<MerchantClientCredentialInfo> {
    const response = await axios.get<MerchantClientCredentialInfo>(`${API_CONFIG.BASE_URL}/merchant-client-credentials`, {
      headers: this.getAuthHeaders(),
    });

    return {
      clientId: response.data?.clientId?.trim() || null,
      clientSecretName: response.data?.clientSecretName?.trim() || null,
      rotatedAtUtc: response.data?.rotatedAtUtc?.trim() || null,
      lastUsedAtUtc: response.data?.lastUsedAtUtc?.trim() || null,
    };
  }

  async generateCredentials(): Promise<MerchantClientCredentialGenerateResponse> {
    const response = await axios.post<MerchantClientCredentialGenerateResponse>(
      `${API_CONFIG.BASE_URL}/merchant-client-credentials`,
      {},
      {
        headers: this.getAuthHeaders(),
      });

    return response.data;
  }

  async deleteCredentials(): Promise<void> {
    await axios.delete(`${API_CONFIG.BASE_URL}/merchant-client-credentials`, {
      headers: this.getAuthHeaders(),
    });
  }
}

export const merchantClientCredentialsService = new MerchantClientCredentialsService();
